import React from 'react';
import { Link } from 'react-router-dom';

import UserInfo from 'containers/UserInfo';
import { prettyKey } from 'helpers/formatters';

const DeviceContractInfo = ({ deviceContract, purchase, sub, attSub }) => {
  const renderPurchase = () => {
    if (!purchase) return null;

    return (
      <React.Fragment>
        <h4>Purchase</h4>
        <table className="table">
          <tbody>
            <tr>
              <td>
                <strong>Id</strong>
              </td>
              <td>{purchase.id}</td>
              <td>
                <Link to={`/purchases/${purchase.id}/view`}>View</Link>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Status</strong>
              </td>
              <td colSpan="2">{purchase.status}</td>
            </tr>
            <tr>
              <td>
                <strong>Total cost</strong>
              </td>
              <td colSpan="2">{purchase.cost.total}</td>
            </tr>
          </tbody>
        </table>
      </React.Fragment>
    );
  };

  const renderLineItem = () => {
    if (!deviceContract || !deviceContract.line_item || !purchase) return null;

    return (
      <React.Fragment>
        <h4>Line Item</h4>
        <table className="table table-striped">
          <thead>
            <tr>
              <td>ID</td>
              <td>Item type</td>
              <td>Title</td>
              <td>Description</td>
              <td>Price</td>
            </tr>
          </thead>
          <tbody>
            {purchase.line_items
              .filter((lineItem) => lineItem.id === deviceContract.line_item)
              .map((line) => (
                <tr key={line.id}>
                  <td>{line.id}</td>
                  <td>{line.item_type}</td>
                  <td>{line.title}</td>
                  <td>{line.description}</td>
                  <td>${line.price}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </React.Fragment>
    );
  };

  const renderSub = () => {
    if (!sub && !attSub) return null;

    const subscription = sub || attSub;
    const subLink = sub
      ? `/subscriptions/${sub.id}/view`
      : `att/subscriptions/${attSub.id}/view`;

    return (
      <React.Fragment>
        <h4>{sub ? 'Sprint subscription' : 'AT&T subscription'}</h4>
        <table className="table">
          <tbody>
            <tr>
              <td>
                <strong>Id</strong>
              </td>
              <td>{subscription.id}</td>
              <td>
                <Link to={subLink}>View</Link>
              </td>
            </tr>
            <tr>
              <td>
                <strong>First Name</strong>
              </td>
              <td colSpan="2">{subscription.first_name}</td>
            </tr>
            <tr>
              <td>
                <strong>Last Name</strong>
              </td>
              <td colSpan="2">{subscription.last_name}</td>
            </tr>
            <tr>
              <td>
                <strong>MDN</strong>
              </td>
              <td colSpan="2">{subscription.mdn}</td>
            </tr>
          </tbody>
        </table>
      </React.Fragment>
    );
  };

  return (
    <div>
      <h2>Device Contract</h2>
      <table className="table">
        <tbody>
          {[
            'id',
            'user_profile',
            'created_at',
            'expiry_date',
            'settled',
            'settled_by',
            'settled_note',
          ].map((attr) => (
            <tr key={attr}>
              <td>
                <strong>{prettyKey(attr)}</strong>
              </td>
              <td>
                {attr === 'user_profile' || attr === 'settled_by' ? (
                  <UserInfo userId={deviceContract[attr]} />
                ) : (
                  deviceContract[attr].toString()
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {renderSub()}
      {renderPurchase()}
      {renderLineItem()}
    </div>
  );
};

export default DeviceContractInfo;
